import React, { Fragment, useEffect, useState } from "react";
import "./coupons.scss";
import TableList from "./TableList";
import Header from "../subheader/Header";
import CouponModal from "../../../components/modal/CouponModal";
import { set_coupons } from "../../../redux/actions/CouponsAction";
import { set_loading } from "../../../redux/actions/LayoutAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";

const Coupons = (props) => {
  const [data, setData] = useState(false);
  const [showModal, setshowModal] = useState(false);

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const getCoupons = (page) =>
    apiJson.coupons.getCoupons(page).then((response) => {
      if (response.success) {
        props.set_coupons({
          coupons: response.data.coupons,
          pagination: response.data.pagination,
        });
        setData(true);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });

  const pageChange = (page) => {
    setData(false);
    getCoupons(page);
  };

  useEffect(() => {
    document.title = "Coupons";
  }, []);

  useEffect(() => {
    getCoupons(1);
    // eslint-disable-next-line
  }, []);

  const cancleClick = () => {
    setshowModal(false);
  };

  const createClick = () => {
    setshowModal(false);
    getCoupons(1);
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right coupons-page-desktop">
        <Header heading="Coupons" search={false} filters={null} />
        {data && (
          <div className="right-content content-container-row">
            <div className="content mx-auto">
              <button
                type="button"
                className="create-button"
                onClick={() => setshowModal(true)}
              >
                Create New Coupon
              </button>
              {showModal && (
                <div className="modal-container">
                  <CouponModal
                    heading="Create Coupon"
                    cancleClick={cancleClick}
                    createClick={createClick}
                  />
                </div>
              )}
              <TableList
                List={props.coupons}
                pageChange={pageChange}
                pagination={props.pagination}
              />
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProsps = (state) => {
  return {
    pagination: state.coupon.pagination,
    coupons: state.coupon.coupons,
    load: state.layout.isLoading,
  };
};

const mapDispatchToProps = {
  set_coupons,
  set_loading,
};

export default connect(mapStateToProsps, mapDispatchToProps)(Coupons);
